// Copyright (c) StrangeBee 2024

import { Button, Space } from 'antd';
import React, { ReactElement, useState } from 'react';
import { FormInstance } from 'antd';
import { useLocalMessage } from '@Helpers/';
import { WidgetIcon } from '@Organisms/Dashboard/DashboardView/constants';
import { WidgetChartType } from 'thehive-sdk';
import THDrawer from '@Molecules/THDrawer/THDrawer';

interface WidgetDrawerProps {
    form: FormInstance;
    children: (
        toggleDrawer: () => void,
        fields: { fieldsTouched: boolean; setFieldsTouched: (value: boolean) => void },
    ) => ReactElement;
    widgetType: WidgetChartType;
}

const WidgetDrawer = ({ widgetType, form, children }: WidgetDrawerProps): ReactElement => {
    const i = useLocalMessage();
    const [fieldsTouched, setFieldsTouched] = useState(false);

    const triggerElement = <Button type="link">{i('app.general.edit')}</Button>;

    const title = (
        <Space>
            {WidgetIcon[widgetType]}
            {i(`dashboard.widget.${widgetType}.title-edit`)}
        </Space>
    );

    return (
        <THDrawer
            title={title}
            triggerElem={triggerElement}
            afterVisibleChange={() => form.resetFields()}
            className="drawer-form"
            width="50vw"
        >
            {(toggleDrawer) => children(toggleDrawer, { fieldsTouched, setFieldsTouched })}
        </THDrawer>
    );
};

export default WidgetDrawer;
